import { createSlice } from "@reduxjs/toolkit";
import { createSignature, fetchSignatures, updateSignature, deleteSignature } from "./signatures.action";

const initialState = {
    signatureData: [],
    loading: false,
    error: null,
};

const signatureSlice = createSlice({
    name: "signatures",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(createSignature.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSignature.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(createSignature.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })


            .addCase(fetchSignatures.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSignatures.fulfilled, (state, action) => {
                state.loading = false;
                state.signatureData = action?.payload;
                state.error = null;
            })
            .addCase(fetchSignatures.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })

            .addCase(updateSignature.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSignature.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateSignature.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })

            .addCase(deleteSignature.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteSignature.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteSignature.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || true;
            })
    },
});

export default signatureSlice.reducer;
